module.exports = __webpack_public_path__ + "img/github.be4672a1.svg";